import { DoubleRightOutlined } from '@ant-design/icons';
import { Modal, ModalProps, Select, Tooltip } from 'antd';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import useAPIQuery from '../api/useAPIQuery';
import { JobPostingDetail, JobPostingId } from '../types';
import Form from './Form';

export interface SelectCandidateFormValues {
  jobPostingId: JobPostingDetail['id'];
}

export interface SelectCandidateModalProps extends ModalProps {
  onFinish?: (values: SelectCandidateFormValues) => void;
  loading?: boolean;
  selectedJobPostings?: ReturnType<typeof JobPostingId>[];
  helmetTitle: string;
}

export default function SelectCandidateModal({
  onFinish,
  loading,
  selectedJobPostings,
  helmetTitle,
  ...props
}: SelectCandidateModalProps) {
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const [search, setSearch] = useState('');

  const jobPostings = useAPIQuery([
    '/job-postings/',
    {
      params: {
        search,
        status: 'IN_PROGRESS',
      },
    },
  ]);

  return (
    <Modal
      okButtonProps={{
        htmlType: 'submit',
        icon: <DoubleRightOutlined />,
        loading,
      }}
      okText={t('Triar')}
      onOk={() => form.submit()}
      {...props}
    >
      <Helmet>
        <title>
          {helmetTitle} | {t('Recrutamento e Seleção')}
        </title>
      </Helmet>
      <Form<SelectCandidateFormValues>
        form={form}
        layout="vertical"
        onFinish={onFinish}
        preserve={false}
      >
        <Form.Item
          name="jobPostingId"
          rules={[
            {
              required: true,
              message: t('É necessário selecionar a vaga para triar o(s) candidato(s)'),
            },
          ]}
        >
          <Select
            showSearch
            filterOption={false}
            searchValue={search}
            onSearch={(value) => setSearch(value)}
            loading={jobPostings.isFetching}
          >
            {jobPostings.data?.results.map((jobPosting) => {
              if (selectedJobPostings?.length !== 0) {
                const selected = selectedJobPostings?.includes(jobPosting.id);

                if (selected) {
                  return (
                    <Select.Option key={jobPosting.id} value={jobPosting.id} disabled>
                      <Tooltip title={t('Candidato já triado')} placement="right">
                        {jobPosting.id} - {jobPosting.name}
                      </Tooltip>
                    </Select.Option>
                  );
                }
              }

              return (
                <Select.Option key={jobPosting.id} value={jobPosting.id}>
                  {jobPosting.id} - {jobPosting.name}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}
